<template>
  <div class="container">
    <div class="content-wrapper">
<!--      <div class="page-header">-->
<!--        <h1>客户案例</h1>-->
<!--        <div class="page-subtitle">专注大型企业设备、银行非现金设备、ATM及智能家电维修服务，展现我们的专业能力和服务品质-->
<!--        </div>-->
<!--      </div>-->
      <div class="service-card">
        <div class="card-header">
          <div class="card-title">工程师现场服务</div>
        </div>
        <div class="card-body">
          <div class="carousel-wrapper">
            <div class="carousel-container">
              <div class="carousel-track" :style="{ transform: `translateX(-${currentCarouselIndex * 100}%)` }">
                <div v-for="item in carouselItems" :key="item.id" class="carousel-slide">
                  <div class="carousel-item">
                    <div class="carousel-image-wrapper">
                      <img :alt="item.title" :src="item.image" class="carousel-image">
                      <div class="carousel-overlay">
                        <h3 class="carousel-title">{{ item.title }}</h3>
                        <div class="carousel-description">{{ item.description }}</div>
                        <div class="carousel-location">
                          <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor">
                            <path
                                d="M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z"></path>
                          </svg>
                          <span>{{ item.location }}</span>
                        </div>
                      </div>
                      <ul class="carousel-dots">
                        <li v-for="(dotItem, dotIndex) in carouselItems" :key="dotItem.id"
                            :class="{ 'carousel-dot-active': currentCarouselIndex === dotIndex }">
                          <button @click.stop="goToSlide(dotIndex)"></button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cases-card">
        <div class="card-header">
          <div class="card-title">成功案例</div>
        </div>
        <div class="card-body">
          <div class="cases-row">
            <div v-for="caseItem in successCases" :key="caseItem.id" class="cases-col">
              <div class="case-card">
                <div class="case-cover">
                  <img :alt="caseItem.title" :src="caseItem.image" class="case-image">
                </div>
                <div class="case-content">
                  <div class="case-header">
                    <h4 class="case-title">{{ caseItem.title }}</h4>
                    <div class="case-tags">
                      <span v-for="(tag, index) in caseItem.tags" :key="index"
                            :class="['case-tag', `case-tag-${caseItem.tagColors[index]}`]">
                        {{ tag }}
                      </span>
                    </div>
                  </div>
                  <div class="case-description">{{ caseItem.description }}</div>
                  <div class="case-info">
                    <div class="case-info-item"><strong>客户：</strong>{{ caseItem.customer }}</div>
                    <div class="case-info-item">
                      <strong>主要成果：</strong>
                      <ul class="case-achievements">
                        <li v-for="(achievement, index) in caseItem.achievements" :key="index">{{ achievement }}</li>
                      </ul>
                    </div>
                  </div>
                  <div class="case-rating">
                    <ul class="rating-stars">
                      <li v-for="n in 5" :key="n" class="rating-star">
                        <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor">
                          <path
                              d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"></path>
                        </svg>
                      </li>
                    </ul>
                    <span class="rating-score">{{ caseItem.rating }}分</span>
                  </div>
                  <div class="case-tags-bottom">
                    <span v-for="(tag, index) in caseItem.caseTags" :key="index" class="case-tag-default">
                      {{ tag }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="testimonials-row">
        <div class="testimonials-col-main">
          <div class="testimonials-card">
            <div class="card-header">
              <div class="card-title">客户评价</div>
            </div>
            <div class="card-body">
              <ul class="testimonials-list">
                <li v-for="testimonial in testimonials" :key="testimonial.id" class="testimonial-item">
                  <div class="testimonial-meta">
                    <div class="testimonial-avatar">
                      <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor">
                        <path
                            d="M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"></path>
                      </svg>
                    </div>
                    <div class="testimonial-content">
                      <h4 class="testimonial-title">
                        <div class="testimonial-name-rating">
                          <span>{{ testimonial.name }}</span>
                          <ul class="rating-stars">
                            <li v-for="(filled, index) in renderStars(testimonial.rating)" :key="index"
                                class="rating-star">
                              <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor">
                                <path
                                    d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"></path>
                              </svg>
                            </li>
                          </ul>
                          <span class="testimonial-tag">{{ testimonial.tag }}</span>
                        </div>
                      </h4>
                      <div class="testimonial-description">
                        <div class="testimonial-text">{{ testimonial.content }}</div>
                        <span class="testimonial-date">
                          <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor">
                            <path
                                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
                            <path
                                d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"></path>
                          </svg>
                          {{ testimonial.date }}
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="testimonials-col-side">
          <div class="solutions-card">
            <div class="card-header">
              <div class="card-title">行业解决方案</div>
            </div>
            <div class="card-body">
              <ul class="solutions-list">
                <li v-for="solution in solutions" :key="solution.id" class="solution-item">
                  <div class="solution-meta">
                    <div class="solution-icon">
                      <svg v-if="solution.icon === 'tool'" viewBox="64 64 896 896" width="1em" height="1em"
                           fill="currentColor">
                        <path
                            d="M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 01144-53.5L537 318.9a32.05 32.05 0 000 45.3l124.5 124.5a32.05 32.05 0 0045.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z"></path>
                      </svg>
                      <svg v-else-if="solution.icon === 'bank'" viewBox="64 64 896 896" width="1em" height="1em"
                           fill="currentColor">
                        <path
                            d="M894 462.3L512.9 74 132 462.3c-16.7 16.7-16.7 43.7 0 60.3l24 24c16.7 16.7 43.7 16.7 60.3 0l242.7-242.7 242.7 242.7c16.7 16.7 43.7 16.7 60.3 0l24-24c16.7-16.6 16.7-43.6 0-60.3z"></path>
                      </svg>
                      <svg v-else viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor">
                        <path
                            d="M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.5 65 63.5h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"></path>
                      </svg>
                    </div>
                    <div class="solution-content">
                      <h4 class="solution-title">{{ solution.title }}</h4>
                      <div class="solution-description">{{ solution.description }}</div>
                      <div class="solution-features">
                        <span v-for="(feature, index) in solution.features" :key="index" class="solution-tag">{{
                            feature
                          }}</span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="faqs-section">
        <div class="faqs-card">
          <div class="card-header">
            <div class="card-title">常见问题</div>
          </div>
          <div class="card-body">
            <ul class="faqs-list">
              <li v-for="faq in faqs" :key="faq.id" class="faq-item">
                <div class="faq-question">{{ faq.question }}</div>
                <div class="faq-answer">{{ faq.answer }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.container {
  display: flex;
  background: #f5f6fa;
  padding-top: 1rem;
}

.content-wrapper {
  width: 75rem;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.page-header {
  text-align: center;
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 2.5rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
}

.page-subtitle {
  font-size: 1.125rem;
  color: #666;
}

/* 服务卡片样式 */
.service-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  margin-bottom: 2rem;
  overflow: hidden;
}

.card-header {
  padding: 1.5rem;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;
}

.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a1a1a;
}

.card-body {
  padding: 1.5rem;
}

/* 轮播图样式 */
.carousel-wrapper {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}

.carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-track {
  display: flex;
  transition: transform 0.5s ease;
  width: 100%;
}

.carousel-slide {
  width: 100%;
  flex-shrink: 0;
}

.carousel-item {
  width: 100%;
}

.carousel-image-wrapper {
  position: relative;
  width: 100%;
  height: 25rem;
  overflow: hidden;
  border-radius: 8px;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  color: white;
  padding: 1.25rem;
  border-radius: 0 0 8px 8px;
}

.carousel-title {
  color: white;
  margin: 0 0 0.5rem 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.carousel-description {
  color: white;
  margin: 0.5rem 0;
  font-size: 1rem;
}

.carousel-location {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  color: white;
  font-size: 0.875rem;
}

.carousel-location svg {
  width: 1em;
  height: 1em;
}

.carousel-dots {
  position: absolute;
  bottom: 0.75rem;
  left: 50%;
  transform: translateX(-50%);
  list-style: none;
  padding: 0.125rem 0.625rem;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.375rem;
  border-radius: 0.5rem;
  z-index: 10;
  width: auto;
}

.carousel-dots li {
  display: inline-block;
}

.carousel-dots button {
  width: 1rem;
  height: 0.25rem;
  border-radius: 0.125rem;
  border: none;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  padding: 0;
  transition: all 0.3s;
}

.carousel-dots button:hover {
  background: rgba(255, 255, 255, 0.8);
}

.carousel-dots .carousel-dot-active button {
  background: #fff;
  height: 0.25rem;
}

/* 成功案例卡片样式 */
.ant-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  margin-bottom: 2rem;
}

.ant-card-head {
  padding: 1.5rem;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;
}

.ant-card-head-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a1a1a;
}

.ant-card-body {
  padding: 1.5rem;
}

.ant-row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -0.75rem;
  margin-right: -0.75rem;
  row-gap: 1.5rem;
}

.ant-col {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.ant-col-xs-24 {
  width: 100%;
}


.ant-card-cover {
  width: 100%;
  overflow: hidden;
}

.ant-card-cover img {
  width: 100%;
  height: 12.5rem;
  object-fit: cover;
}

.ant-typography {
  margin: 0;
  color: #1a1a1a;
}

.ant-space {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ant-tag {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  font-size: 0.75rem;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  background: #fafafa;
  color: #1a1a1a;
}

.ant-tag-blue {
  background: #e6f7ff;
  border-color: #91d5ff;
  color: #1890ff;
}

.ant-tag-green {
  background: #f6ffed;
  border-color: #b7eb8f;
  color: #52c41a;
}

.ant-rate {
  display: inline-flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 0.25rem;
}

.ant-rate-star {
  font-size: 1rem;
  color: #fadb14;
}

.ant-rate-star svg {
  width: 1em;
  height: 1em;
}


/* 客户评价和行业解决方案布局 */
.testimonials-row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -0.75rem;
  margin-right: -0.75rem;
  row-gap: 1.5rem;
  align-items: stretch;
}

.testimonials-col-main {
  flex: 0 0 66.666667%;
  width: 66.666667%;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  display: flex;
}

.testimonials-col-side {
  flex: 0 0 33.333333%;
  width: 33.333333%;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  display: flex;
}

/* 客户评价样式 */
.testimonials-card,
.solutions-card,
.faqs-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  margin-bottom: 2rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.testimonials-card .card-body,
.solutions-card .card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.testimonials-list,
.solutions-list,
.faqs-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.testimonial-item,
.solution-item,
.faq-item {
  padding: 1.5rem;
  border-bottom: 1px solid #f0f0f0;
}

.testimonial-item:last-child,
.solution-item:last-child,
.faq-item:last-child {
  border-bottom: none;
}

.testimonial-meta,
.solution-meta {
  display: flex;
  gap: 1rem;
}

.testimonial-avatar,
.solution-icon {
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1890ff;
}

.testimonial-content,
.solution-content {
  flex: 1;
}

.testimonial-title,
.solution-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.5rem 0;
}

.testimonial-name-rating {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.rating-stars {
  display: inline-flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 0.25rem;
}

.rating-star {
  color: #fadb14;
  font-size: 1rem;
}

.rating-star svg {
  width: 1em;
  height: 1em;
}

.testimonial-tag {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  background: #e6f7ff;
  color: #1890ff;
  border-radius: 4px;
  font-size: 0.75rem;
  margin-left: 0.5rem;
}

.testimonial-description {
  margin-top: 0.5rem;
}

.testimonial-text {
  color: #666;
  font-size: 0.875rem;
  line-height: 1.5;
  margin-bottom: 0.5rem;
}

.testimonial-date {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #999;
  font-size: 0.75rem;
}

.testimonial-date svg {
  width: 1em;
  height: 1em;
}

/* 行业解决方案样式 */
.solution-description {
  color: #666;
  font-size: 0.875rem;
  line-height: 1.5;
  margin-bottom: 0.5rem;
}

.solution-features {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.solution-tag {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  background: #f0f0f0;
  color: #666;
  border-radius: 4px;
  font-size: 0.75rem;
}

/* 常见问题样式 */
.faqs-section {
  margin-top: 2rem;
}

.faq-question {
  font-size: 1rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
}

.faq-answer {
  color: #666;
  font-size: 0.875rem;
  line-height: 1.5;
}

/* 成功案例卡片样式 */
.cases-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  margin-bottom: 2rem;
  overflow: hidden;
}

.cases-row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -0.75rem;
  margin-right: -0.75rem;
  row-gap: 1.5rem;
}

.cases-col {
  flex: 0 0 33.333333%;
  width: 33.333333%;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.case-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s;
}

.case-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.case-cover {
  width: 100%;
  height: 12.5rem;
  overflow: hidden;
  background: #f0f0f0;
}

.case-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.case-card:hover .case-image {
  transform: scale(1.05);
}

.case-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
}

.case-header {
  margin-bottom: 1rem;
}

.case-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.5rem 0;
}

.case-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.case-tag {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  font-size: 0.75rem;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}

.case-tag-blue {
  background: #e6f7ff;
  border-color: #91d5ff;
  color: #1890ff;
}

.case-tag-green {
  background: #f6ffed;
  border-color: #b7eb8f;
  color: #52c41a;
}

.case-description {
  color: #666;
  font-size: 0.875rem;
  line-height: 1.5;
  margin-bottom: 1rem;
  flex: 1;
}

.case-info {
  margin-bottom: 1rem;
}

.case-info-item {
  font-size: 0.875rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.case-info-item strong {
  color: #1a1a1a;
  font-weight: 600;
}

.case-achievements {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0 0;
}

.case-achievements li {
  font-size: 0.875rem;
  color: #666;
  margin-bottom: 0.25rem;
  padding-left: 1rem;
  position: relative;
}

.case-achievements li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: #1890ff;
}

.case-rating {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.rating-score {
  font-size: 0.875rem;
  color: #666;
}

.case-tags-bottom {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.case-tag-default {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  background: #f0f0f0;
  color: #666;
  border-radius: 4px;
  font-size: 0.75rem;
}

</style>
<script setup>
import {ref, onMounted, onUnmounted} from 'vue'

// 轮播图数据
const carouselItems = ref([
  {
    id: 1,
    title: '大型企业设备管理项目',
    description: '为某大型制造企业提供设备全生命周期管理服务，包括设备档案管理、维护计划制定、成本控制分析等。',
    location: '深圳市南山区',
    image: require('@/assets/images/充电桩维修.png')
  },
  {
    id: 2,
    title: 'ATM机维护服务',
    description: '专业团队为银行提供ATM机日常维护和故障处理',
    location: '北京市朝阳区',
    image: require('@/assets/images/金融设备维修.jpeg')
  },
  {
    id: 1,
    title: '银行非现金设备维修',
    description: '专业工程师正在检修银行自助终端设备',
    location: '上海市浦东区',
    image: require('@/assets/images/CP500维护.png')
  },
])

// 当前轮播图索引
const currentCarouselIndex = ref(0)
let carouselInterval = null

// 切换轮播图
function goToSlide(index) {
  currentCarouselIndex.value = index
}

// 自动播放
function autoPlay() {
  carouselInterval = setInterval(function () {
    currentCarouselIndex.value = (currentCarouselIndex.value + 1) % carouselItems.value.length
  }, 5000)
}

// 成功案例数据
const successCases = ref([
  {
    id: 1,
    title: '银行非现金设备维护项目',
    description: '为多家银行提供自助终端、制卡机等非现金设备的全生命周期维护服务，包括日常巡检、预防性维护、故障快速响应等。',
    customer: '多家银行',
    image: require('@/assets/images/CP500维护.png'),
    tags: ['金融业', '24个月'],
    tagColors: ['blue', 'green'],
    achievements: [
      '设备故障率降低45%',
      '维护成本节省30%',
      '设备可用率达到99.8%'
    ],
    rating: 5.0,
    caseTags: ['非现金设备', '银行设备', '预防性维护']
  },
  {
    id: 3,
    title: 'ATM机维护服务',
    description: '为多家银行提供ATM机日常维护和故障处理服务，确保设备稳定运行，保障客户正常使用。',
    customer: '多家银行',
    image: require('@/assets/images/金融设备维修.jpeg'),
    tags: ['金融业', '持续服务'],
    tagColors: ['blue', 'green'],
    achievements: [
      '设备可用率达到99.9%',
      '故障响应时间缩短至30分钟',
      '客户满意度达到98%'
    ],
    rating: 5.0,
    caseTags: ['ATM维护', '快速响应', '高可用性']
  },
  {
    id: 2,
    title: '大型企业设备管理项目',
    description: '为某大型企业提供设备全生命周期管理服务，包括设备档案管理、维护计划制定、成本控制分析等。',
    customer: '大型企业',
    image: require('@/assets/images/充电桩维修.png'),
    tags: ['制造业', '12个月'],
    tagColors: ['blue', 'green'],
    achievements: [
      '设备故障率降低45%',
      '维护成本节省30%',
      '设备可用率达到99.8%'
    ],
    rating: 5.0,
    caseTags: ['设备管理', '成本控制', '效率提升']
  }
])

// 客户评价数据
const testimonials = ref([
  {
    id: 1,
    name: '张经理',
    rating: 5,
    tag: '银行自助终端',
    content: '自助终端设备维修服务非常专业，工程师技术过硬，故障响应速度快，设备运行稳定，非常满意！',
    date: '2025-01-15'
  },
  {
    id: 2,
    name: '李主任',
    rating: 5,
    tag: 'ATM机维护',
    content: 'ATM机维护服务很及时，工程师专业素养很高，设备可用率大幅提升，值得信赖。',
    date: '2025-01-10'
  },
  {
    id: 4,
    name: '陈先生',
    rating: 5,
    tag: '制卡机维护',
    content: '制卡机维护服务很贴心，预防性维护做得很好，设备故障率明显降低，很实用。',
    date: '2025-01-05'
  }
])

// 常见问题数据
const faqs = ref([
  {
    id: 1,
    question: '如何预约维修服务？',
    answer: '您可以通过我们的官网、电话或微信小程序预约维修服务。对于银行设备，我们提供7×24小时应急响应服务；对于智能家电，我们会根据您的时间安排工程师上门服务。'
  },
  {
    id: 2,
    question: '维修费用如何计算？',
    answer: '维修费用包括上门费、检测费和维修费。银行设备维护通常采用年度维护合同方式，费用更优惠；智能家电维修费用根据设备类型和故障情况而定，我们会在检测后提供详细的报价。'
  },
  {
    id: 3,
    question: '维修后是否有保修期？',
    answer: '是的，我们提供维修后3-6个月的保修期，具体保修时间根据维修项目而定。在保修期内，如果出现同样的问题，我们免费维修。银行设备维护合同客户享受更长的保修期。'
  },
  {
    id: 4,
    question: '可以维修哪些类型的设备？',
    answer: '我们主要维修银行非现金设备（如自助终端、制卡机、查询机等）、ATM机以及智能家电（如智能空调、智能冰箱、智能洗衣机等）。如果您不确定您的设备是否可以维修，可以联系我们的客服咨询。'
  }
])

// 行业解决方案数据
const solutions = ref([
  {
    id: 1,
    icon: 'bank',
    title: '银行非现金设备解决方案',
    description: '为银行提供自助终端、制卡机、查询机等非现金设备的全生命周期维护服务',
    features: ['7×24小时应急响应', '预防性维护计划', '设备可用率保障']
  },
  {
    id: 2,
    icon: 'bank',
    title: 'ATM机维护解决方案',
    description: '为银行提供ATM机日常维护、故障处理、升级改造等专业服务',
    features: ['高可用性保障', '30分钟快速响应', '专业维护团队']
  },
  {
    id: 3,
    icon: 'home',
    title: '智能充电桩解决方案',
    description: '为家庭用户提供智能空调、智能冰箱、智能洗衣机等智能家电的维修服务',
    features: ['2小时快速上门', '透明价格体系', '贴心售后服务']
  }
])

// 生成星星评分的辅助函数
function renderStars(rating) {
  return Array.from({length: 5}, function (_, i) {
    return i < rating
  })
}

// 组件挂载后开始自动播放
onMounted(function () {
  autoPlay()
})

onUnmounted(function () {
  if (carouselInterval) {
    clearInterval(carouselInterval)
  }
})
</script>